import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";

export interface AccountInfo {
  _id: mongoose.Schema.Types.ObjectId;
  name: string;
  email: string;
  phoneNumber?: string;
  bio?: string;
  customerIds?: string[];
}

export const AccountInfoSchema = new mongoose.Schema<AccountInfo>({
    name: { type: String, required: true },
    email: { type: String, required: true, unique: true },
    phoneNumber: String,
    bio: String,
    customerIds: { type: [String], index: true },  
});

export const props: (keyof AccountInfo)[] = [
    "_id",
    "name",
    "email",
    "phoneNumber",
    "bio",
  ];
  
  export const searchProps: (keyof AccountInfo)[] = [
    "_id",
    "name",
    "email",
    "phoneNumber",
  ];
  
  export function matches(a: AccountInfo, b: AccountInfo): boolean {
    return match(a, b, props);
  }
  
  export const accountInfoUtils = {
    props,
    searchProps,
    matches,
  };
